export const applyFilters = (data, filters) => {
  const { treeNames, locations, surveyTypes } = filters;

  return data.filter((item) => {
    const matchesTreeName = !treeNames.length || treeNames.includes(item.properties.tree_name);
    const matchesLocation = !locations.length || locations.includes(item.properties.station_name);
    const matchesSurveyType = !surveyTypes.length || surveyTypes.includes(item.properties.survey_type);

    // Include items that match all selected criteria
    return matchesTreeName && matchesLocation && matchesSurveyType;
  });
};
